import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import "./batches.scss";
import Label from "../../../components/Label/Label";
import PartialBatchMissingValueNote from "../../../components/PartialBatchMissingValueNote/PartialBatchMissingValueNote";
import { PARTIAL_BATCH_MISSING_VALUE_COLORS } from "../../../constants/analyticsBatches";
import { isBlankBatchValue } from "../../../utils/batchesUtility";

export default function ParameterTable({
  data,
  batchDetails,
  isPartialBatch = false,
}) {
  const headers = Array.from(
    new Set(data?.rows?.flatMap((obj) => Object.keys(obj)) || [])
  );
  //  const headers = []
  return (
    <Box width="100%">
      {isPartialBatch && (
        <Box mb={1}>
          <PartialBatchMissingValueNote />
        </Box>
      )}
      <TableContainer
        component={Paper}
        overflow="auto"
        className="audit-table-container"
        sx={{
          maxHeight: "calc(100vh - 250px)",
          boxShadow: "none",
          overflow: "auto",
        }}
      >
        <Table stickyHeader>
          <TableHead className="table-header">
            <TableRow>
              {headers.map((key) => (
                <TableCell
                  className="table-header-cell"
                  key={key}
                  sx={{ fontWeight: "bold" }}
                >
                  {key}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.rows?.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map((key) => {
                  const isMissing =
                    isPartialBatch && isBlankBatchValue(row[key]);

                  return (
                    <TableCell
                      key={key}
                      sx={{
                        fontSize: 14,
                        backgroundColor: isMissing
                          ? PARTIAL_BATCH_MISSING_VALUE_COLORS.background
                          : undefined,
                        boxShadow: isMissing
                          ? `inset 0 0 0 1px ${PARTIAL_BATCH_MISSING_VALUE_COLORS.border}`
                          : undefined,
                      }}
                    >
                      {isBlankBatchValue(row[key]) ? "-" : row[key]}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
            {(!batchDetails?.loader && data?.rows?.length === 0) || (data === undefined || data?.rows?.length === 0 )  ? (
              <TableRow>
                <TableCell colSpan={headers?.length || 7} align="center">
                  <Label color="textSecondary" text={"No data found"} />
                </TableCell>
              </TableRow>
            ): null}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
